import React from 'react';
import './style_Table.scss';

export const ATQ_Table_Component = () => {
    
        const information = [
            {
                Sistema: 'Add plus',
                Ubicacion:'ADD PLUS 12',
                Cantidad:'4'
            },
            {
                Sistema: 'Tetris',
                Ubicacion:'TETRIS 7',
                Cantidad:'1'
            },
            {
                Sistema: 'Tetris',
                Ubicacion:'TETRIS 8',
                Cantidad:'1'
            },
            {
                Sistema: 'Set de Cucharillas',
                Ubicacion:'CUCHARILLAS',
                Cantidad:'1'
            },
            {
                Sistema: 'Phantom Cervical',
                Ubicacion:'PHANTOM 2',
                Cantidad:'1'
            },
            {
                Sistema: 'Tava',
                Ubicacion:'TAVA 4',
                Cantidad:'1'
            },
            {
                Sistema: 'Maletin Fuente de Luz',
                Ubicacion:'Maletín 1',
                Cantidad:'1'
            },
            {
                Sistema: 'Instrumental Lumbar',
                Ubicacion:'INSTRUMENTAL 9',
                Cantidad:'1'
            },
        ]
        return (
            <>
            <div className="TableUbication2-precontainer">
                <div className="TableUbication2-container">
                    <table className="TableUbication2-table-container">
                        <thead className="TableUbication2-table-thead">
                            <tr className="TableUbication2-table-row">
                                <th className="TableUbication2-table-title">{'Ubicacion'}</th>
                                <th className="TableUbication2-table-title">{'Cantidad'}</th>
                            </tr>
                        </thead>
                        <tbody className="TableUbication2-table-body">
                        {
                            information.map(item => (
                                <tr className="TableUbication2-table-body-row">
                                    <td className="TableUbication2-table-data">{item.Ubicacion}</td>
                                    <td className="TableUbication2-table-data">{item.Cantidad}</td>
                                </tr>
                            ))        
                        }
                        </tbody>
                    </table>
                </div>
            </div>
        </>
        
    )
}
